/**
 * Fonction utilitaire pour construire l'URL complète d'une image
 * @param {string|null|undefined} imagePath - Le chemin de l'image retourné par l'API (ex: "products/filename.jpg")
 * @returns {string|null} - L'URL complète de l'image ou null si le chemin est vide
 */
export function getImageUrl(imagePath) {
  // Si le chemin est vide ou null, retourner null
  if (!imagePath) {
    return null;
  }

  // Si c'est déjà une URL complète (http:// ou https://), la retourner telle quelle
  // Cela permet de gérer les aperçus de fichiers locaux (blob: URLs)
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('blob:')) {
    return imagePath;
  }

  // Construire l'URL complète : API_URL + /storage/ + chemin
  // Utiliser l'URL de l'API définie dans la configuration ou détecter depuis le contexte
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  return `${API_URL}/storage/${imagePath}`;
}




